<template>
<el-dialog style="padding-bottom:10px;" title="Bill List" :visible.sync="modal" top="8vh" @close="() => this.search = ''">
    <div class="mb-2 mt-n8">
        <el-input prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
    </div>
    <template #title>
        <span v-if="batchId" class="white--text">Batch ID: <strong>{{ batchId }}</strong></span><br>
        <el-tag class="mr-1" effect="dark" type="success">Success: {{ totalSuccess }}</el-tag>
        <el-tag effect="dark" type="danger">Error: {{ totalError }}</el-tag>
    </template>
    <div class="pb-5">
        <e-table :headers="headers" :data="items" :total="items.length" :search="search" :height="window.height - 300" :loading="loading">
            <template #footer>
                <v-export-table text="Export" :tableColumns="exportColumns" :tableData="items" :filename="`QB_LOG_STATUS_${batchId}-${Date.now()}`" :filesheet="`status`"></v-export-table>
            </template>
        </e-table>
    </div>
</el-dialog>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import * as type from '../../../store/types';
export default {
    data: () => ({
        modal: false,
        search: '',
        batchId: '',
        totalSuccess: '',
        totalError: '',
        headers: [{
                text: 'Invoice No.',
                value: 'invoice_no',
                width: "120",
                sortable: true
            },
            {
                text: 'Status',
                value: 'status',
                width: "120",
                sortable: true
            },
            {
                text: 'Status Description',
                value: 'status_description',
                sortable: true
            }
        ],
        exportColumns: [{
                label: 'Batch ID',
                field: 'batch_id'
            },
            {
                label: 'Invoice Number',
                field: 'invoice_no'
            },
            {
                label: 'Status',
                field: 'status_code'
            },
            {
                label: 'Status Description',
                field: 'status_description'
            }
        ]
    }),
    computed: {
        ...mapGetters({
            items: 'quickbooklogs/itemsByBatchId',
            loading: 'quickbooklogs/loading2',
        }),
    },
    methods: {
        ...mapActions({
            loadQBLogsByBatchId: `quickbooklogs/${type.QB_GET_LOGS_BY_BATCHID}`,
        }),
        viewBillsList(batchId) {
            this.totalSuccess = 0
            this.totalError = 0
            this.modal = true
            this.batchId = batchId;
            this.loadQBLogsByBatchId(batchId)
                .then(data => {
                    this.totalSuccess = data.filter(item => item.batch_id === batchId && item.status_code === '200').length;
                    this.totalError = data.filter(item => item.batch_id === batchId && item.status_code === '6140').length;
                })
        }
    }
}
</script>
